import React, {
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";

import { ThirdWBSAPI,MeasureAPI} from "../services/api";
import { useSession } from "../context/SessionContext";

import * as XLSX from "xlsx"; 


type Props = {
  selectedWorkTreeNode: number |null;
   onNotationSelect?: (node: any) => void;
};

type AnyObj = Record<string, any>;

const EXCEL_DEFAULT_COL_WIDTH = 120;

export default function NotationExcelSheet({
  selectedWorkTreeNode,
    onNotationSelect,
}: Props) {

  //const tableRef = useRef<HTMLDivElement>(null);
  const tableRef = useRef<HTMLDivElement | null>(null);

  const { sessionNo } = useSession();

  const [loading,setLoading]=useState(false);

  const [error,setError]=useState("");

  const [data,setData]=useState({
    accordions:[],
    columns:[],
    rows:[]
  });

  const [collapsedGroups, setCollapsedGroups] =
  useState<Set<string>>(new Set());


  const [selectedCell, setSelectedCell] = useState<{
  row: number;
  col: number;
} | null>(null);

const [editingCell, setEditingCell] = useState<{
    row: number;
    col: number;
} | null>(null);

const [editValue, setEditValue] = useState("");

const [selectionStart, setSelectionStart] = useState<{
  row: number;
  col: number;
} | null>(null);

const [selectionEnd, setSelectionEnd] = useState<{
  row: number;
  col: number;
} | null>(null);

const [isSelecting, setIsSelecting] = useState(false);

const [columnWidths, setColumnWidths] = useState<
  Record<string, number>
>({});

const resizeRef = useRef<{
  key: string;
  startX: number;
  startWidth: number;
} | null>(null);

const dragStartedRef = useRef(false);

const lastClickRef = useRef(0);

const clickColumnRef = useRef("");


  useEffect(()=>{

    if(!selectedWorkTreeNode){

      setData({
        accordions:[],
        columns:[],
        rows:[]
      });

      return;
    }

    const load=async()=>{

      try{

        setLoading(true);

        const res=
        await ThirdWBSAPI.getNotationAccordionMatrix(
          selectedWorkTreeNode
        );

        setData({

          accordions:
            res?.accordions ||
            res?.Accordions ||
            [],

          columns:
            res?.columns ||
            res?.Columns ||
            [],

          rows:
            res?.rows ||
            res?.Rows ||
            []

        });

      }

      catch(err:any){

        setError(
          err?.message ??
          "Failed to load."
        );

      }

      finally{

        setLoading(false);

      }

    };

    load();

  },[selectedWorkTreeNode]);
  const groups = useMemo(() => {

  return (data.accordions as AnyObj[]).map((acc) => {

    const key =
      acc.accordionKey ||
      acc.AccordionKey ||
      "";

    const title =
      acc.headNotationName ||
      acc.HeadNotationName ||
      `Notation Head ${acc.notationHead ?? acc.NotationHead ?? ""}`;

    const columns = (data.columns as AnyObj[]).filter((c) => {

      return (
        String(c.accordionKey || c.AccordionKey) ===
        String(key)
      );

    });

    const rows = (data.rows as AnyObj[]).filter((r) => {

      return (
        String(r.accordionKey || r.AccordionKey) ===
        String(key)
      );

    });

    const rowMap = new Map<number, AnyObj>();

    rows.forEach((r) => {

      const notationNo =
        Number(r.notationNo ?? r.NotationNo);

      const columnName =
        String(r.columnName ?? r.ColumnName ?? "");

      const value =
        r.value ??
        r.Value ??
        "";

      /* const existing =
        rowMap.get(notationNo) || {

          notationNo,

          notation:
            r.notation ??
            r.Notation,

          values:{}

        }; */

        const existing =
  rowMap.get(notationNo) || {

    notationNo,

    notation:
      r.notation ??
      r.Notation,

    tag:
      r.tag ??
      r.Tag,

    notationHead:
      r.notationHead ??
      r.NotationHead,

    values: {},

      parameterNos: {}      // <-- ADD THIS

  };

      existing.values[columnName]=value;

      existing.parameterNos[columnName] =
    r.parameterNo ?? r.ParameterNo;

      rowMap.set(
        notationNo,
        existing
      );

    });

    return{

      key,

      title,

      columns,

      rows:Array.from(
        rowMap.values()
      ).sort(
        (a,b)=>a.notationNo-b.notationNo
      )

    };

  });

},[data]);
const maxColumns = useMemo(() => {

  return Math.max(
    0,
    ...groups.map(g=>g.columns.length)
  );

},[groups]);

const totalColumns = maxColumns + 2;


const hasMatrices = groups.some(group => group.rows.length > 0);
type SheetRow =

|{

    type:"group";

    group:any;

 }

|{

    type:"header";

    group:any;

 }

|{

    type:"data";

    group:any;

    row:any;

    rowIndex:number;

 };
 const sheetRows = useMemo(() => {

  const rows:SheetRow[]=[];

  groups.forEach(group=>{

   
rows.push({

  type:"group",

  group

});

if (!collapsedGroups.has(group.key)) {

  rows.push({

    type:"header",

    group

  });


group.rows.forEach((row: any, rowIndex: number) => {

  rows.push({

    type: "data",

    group,

    row,

    rowIndex

  });

});
 }


  });

  return rows;

//},[groups]);
},[groups, collapsedGroups]);

const toggleGroup = (groupKey: string) => {

  setCollapsedGroups(prev => {

    const next = new Set(prev);

    if (next.has(groupKey)) {
      next.delete(groupKey);
    } else {
      next.add(groupKey);
    }

    return next;

  });

};

const isCellSelected = (
  row: number,
  col: number
) => {

  if (!selectionStart || !selectionEnd)
    return false;

  const minRow = Math.min(
    selectionStart.row,
    selectionEnd.row
  );

  const maxRow = Math.max(
    selectionStart.row,
    selectionEnd.row
  );

  const minCol = Math.min(
    selectionStart.col,
    selectionEnd.col
  );

  const maxCol = Math.max(
    selectionStart.col,
    selectionEnd.col
  );

  return (
    row >= minRow &&
    row <= maxRow &&
    col >= minCol &&
    col <= maxCol
  );

};

const selectAllCells = () => {

  tableRef.current?.focus();

  setSelectedCell({
    row: 0,
    col: 0
  });

  setSelectionStart({
    row: 0,
    col: 0
  });

   setSelectionEnd({
    row: sheetRows.length - 1,
    col: totalColumns - 1
  }); 
 

};


const selectGroup = (groupKey: string) => {

  const firstRow = sheetRows.findIndex(r =>
    r.group?.key === groupKey
  );

  const lastRow = (() => {

    let last = firstRow;

    for (let i = firstRow + 1; i < sheetRows.length; i++) {

      if (
        sheetRows[i].type === "group"
      ) {
        break;
      }

      last = i;

    }

    return last;

  })();

  tableRef.current?.focus();

  setSelectedCell({
    row: firstRow + 1,
    col: 0
});

setSelectionStart({
    row: firstRow + 1,
    col: 0
});

  setSelectionEnd({
    row: lastRow,
    col: totalColumns - 1
  }); 

 

};

const copySelection = async () => {

  if (!selectionStart || !selectionEnd)
    return;

  const minRow = Math.min(selectionStart.row, selectionEnd.row);
  const maxRow = Math.max(selectionStart.row, selectionEnd.row);

  const minCol = Math.min(selectionStart.col, selectionEnd.col);
  const maxCol = Math.max(selectionStart.col, selectionEnd.col);

  let clipboard = "";

  for (let r = minRow; r <= maxRow; r++) {

    const row = sheetRows[r];

    if (!row || row.type === "group")
      continue;

    const values: string[] = [];

    let lastSelectedCol = maxCol;

if (row.type === "header" || row.type === "data") {

  while (
    lastSelectedCol > 1 &&
    !row.group.columns[lastSelectedCol - 2]
  ) {
    lastSelectedCol--;
  }

}

    //for (let c = minCol; c <= maxCol; c++) {
    for (let c = minCol; c <= lastSelectedCol; c++) {

      if (row.type === "header") {

        if (c === 0) {

          values.push("S.No");

        } else if (c === 1) {

          values.push("Notation");

        } else {

          const col = row.group.columns[c - 2];

          values.push(
            col
              ? (
                  col.columnCaption ||
                  col.ColumnCaption ||
                  col.columnName ||
                  col.ColumnName ||
                  ""
                )
              : ""
          );

        }

      } else {

        if (c === 0) {

          values.push(String(row.rowIndex + 1));

        } else if (c === 1) {

          values.push(row.row.notation);

        } else {

          const col = row.group.columns[c - 2];

          if (!col) {

            values.push("");

          } else {

            const key =
              col.columnName ||
              col.ColumnName;

            values.push(
              String(
                row.row.values[key] ?? ""
              )
            );

          }

        }

      }

    }

    clipboard += values.join("\t") + "\n";

  }

  await navigator.clipboard.writeText(clipboard);

};

const exportToExcel = () => {

  const excelData: any[][] = [];

  sheetRows.forEach(item => {

    if (item.type === "group") {

      excelData.push([item.group.title]);

      return;

    }

    if (item.type === "header") {

      const header = [
        "S.No",
        "Notation"
      ];

      item.group.columns.forEach((c: any) => {

        header.push(
          c.columnCaption ||
          c.ColumnCaption ||
          c.columnName ||
          c.ColumnName ||
          ""
        );

      });

      excelData.push(header);

      return;

    }

    const row = [
      item.rowIndex + 1,
      item.row.notation
    ];

    item.group.columns.forEach((c: any) => {

      const key =
        c.columnName ||
        c.ColumnName;

      row.push(
        item.row.values[key] ?? ""
      );

    });

    excelData.push(row);

  });

  const worksheet =
    XLSX.utils.aoa_to_sheet(excelData);

  const workbook =
    XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Notation"
  );

  XLSX.writeFile(
    workbook,
    "Notation.xlsx"
  );

};

const handleKeyDown = (
  e: React.KeyboardEvent<HTMLDivElement>
) => {

 // if (!selectedCell) return;
 if (!selectedCell) return;

if (e.ctrlKey && e.key.toLowerCase() === "c") {

  e.preventDefault();

  copySelection();

  return;

}

  let row = selectedCell.row;
  let col = selectedCell.col;

  const maxRow = sheetRows.length - 1;
  const maxCol = totalColumns - 1;

  switch (e.key) {

    case "ArrowUp":
      e.preventDefault();
      row = Math.max(0, row - 1);
      break;

    case "ArrowDown":
      e.preventDefault();
      row = Math.min(maxRow, row + 1);
      break;

    case "ArrowLeft":
      e.preventDefault();
      col = Math.max(0, col - 1);
      break;

    case "ArrowRight":
      e.preventDefault();
      col = Math.min(maxCol, col + 1);
      break;

    case "Tab":
      e.preventDefault();

      if (e.shiftKey) {

        if (col > 0) {
          col--;
        } else if (row > 0) {
          row--;
          col = maxCol;
        }

      } else {

        if (col < maxCol) {
          col++;
        } else if (row < maxRow) {
          row++;
          col = 0;
        }

      }

      break;

    case "Enter":
      e.preventDefault();

      if (e.shiftKey) {
        row = Math.max(0, row - 1);
      } else {
        row = Math.min(maxRow, row + 1);
      }

      break;

    default:
      return;
  }

  setSelectedCell({
    row,
    col,
  });

  if (e.shiftKey) {

    setSelectionEnd({
      row,
      col,
    });

  } else {

    setSelectionStart({
      row,
      col,
    });

    setSelectionEnd({
      row,
      col,
    });

  }

};


const getWidth = (key: string) => {

  return (
    columnWidths[key] ??
    EXCEL_DEFAULT_COL_WIDTH
  );

};
function handleResizeMove(e: PointerEvent) {
  if (!resizeRef.current) return;

  const { key, startX, startWidth } = resizeRef.current;

  const delta = e.clientX - startX;

  if (!dragStartedRef.current) {
    if (Math.abs(delta) < 4) return;
    dragStartedRef.current = true;
  }

  setColumnWidths(prev => ({
    ...prev,
    [key]: Math.max(60, startWidth + delta),
  }));
}

function handleResizeEnd() {
  document.body.style.userSelect = "";

  resizeRef.current = null;
  dragStartedRef.current = false;

  window.removeEventListener(
    "pointermove",
    handleResizeMove
  );

  window.removeEventListener(
    "pointerup",
    handleResizeEnd
  );
}

/* const startResize = (
  e: React.MouseEvent,
  key: string
) => {
 */
/* const startResize = (
  e: React.PointerEvent,
  key: string
) => {

  e.preventDefault();

  const startX = e.clientX;

  const startWidth = getWidth(key);

  const onMove = (ev: MouseEvent) => {

    const width = Math.max(
      50,
      startWidth + (ev.clientX - startX)
    );

    setColumnWidths(prev => ({
      ...prev,
      [key]: width
    }));

  };

  const onUp = () => {

    window.removeEventListener(
      "mousemove",
      onMove
    );

    window.removeEventListener(
      "mouseup",
      onUp
    );

  };

  window.addEventListener(
    "mousemove",
    onMove
  );

  window.addEventListener(
    "mouseup",
    onUp
  );

}; */
const startResize = (
  e: React.PointerEvent,
  key: string
) => {

  e.preventDefault();
  e.stopPropagation();

  document.body.style.userSelect = "none";

 /*  const now = Date.now();

  if (
    clickColumnRef.current === key &&
    now - lastClickRef.current < 300
  ) {

    lastClickRef.current = 0;

    autoFitColumn(key);

    return;
  }

  clickColumnRef.current = key;
  lastClickRef.current = now; */

  dragStartedRef.current = false;

  resizeRef.current = {
    key,
    startX: e.clientX,
    startWidth:
      columnWidths[key] ??
      EXCEL_DEFAULT_COL_WIDTH
  };

  window.addEventListener(
    "pointermove",
    handleResizeMove
  );

  window.addEventListener(
    "pointerup",
    handleResizeEnd
  );
};

const autoFitColumn = (key: string) => {

  let maxLength = key.length;

  sheetRows.forEach(item => {

    if (item.type !== "data") return;

    let text = "";

    if (key === "notation") {

      text = String(item.row.notation ?? "");

    } else {

      text = String(item.row.values[key] ?? "");

    }

    maxLength = Math.max(
      maxLength,
      text.length
    );

  });

  setColumnWidths(prev => ({
    ...prev,
    [key]: Math.max(
      60,
      maxLength * 8 + 24
    )
  }));

};

/* const saveCell = async (
  item: any,
  columnName: string,
  value: string
) => {

  try {

    await MeasureAPI.update({

      //wmno: item.row.notationNo,
           wmno: item.row.parameterNos[columnName],

      sno: sessionNo!,

      mval: Number(value),

      axn: "ParameterUpdate"

    });

    item.row.values[columnName] = value;

    setData({ ...data });

  }
  catch (err) {

    console.error(err);

  }

  setEditingCell(null);

}; */
const saveCell = async (
  item: any,
  columnName: string,
  value: string
) => {

  try {

    await MeasureAPI.update({

      wmno: item.row.parameterNos[columnName],

      sno: sessionNo!,

      mval: Number(value),

      axn: "ParameterUpdate"

    });

    // Reload latest data from SQL
    const res =
      await ThirdWBSAPI.getNotationAccordionMatrix(
        selectedWorkTreeNode!
      );

    setData({

      accordions:
        res?.accordions ||
        res?.Accordions ||
        [],

      columns:
        res?.columns ||
        res?.Columns ||
        [],

      rows:
        res?.rows ||
        res?.Rows ||
        []

    });

  }
  catch (err) {

    console.error(err);

  }

  setEditingCell(null);

};


const styles = {



  table:{
    borderCollapse:"collapse" as const,
    width:"max-content",
    background:"#fff"
  },

  th:{
  border:"1px solid #c7c7c7",
  
    background:"#ececec",
    padding:"4px",
    fontSize:"13px",
    fontWeight:400,
    textAlign:"center" as const,
    height:"24px"
  },

  td:{
    border:"1px solid #c7c7c7",
  
    padding:"4px",
    whiteSpace:"nowrap" as const,
    height:"22px"
  },

  group:{
    border:"1px solid #c7c7c7",
    background:"#d9d9d9",
    fontWeight:600,
    padding:"6px"
  }

};

return(

<div
ref={tableRef}
tabIndex={0}
onKeyDown={handleKeyDown}
onMouseUp={()=>{
    setIsSelecting(false);
}}
style={{
width:"100%",
height:"100%",
overflow:"auto",
background:"#fff",
//border:"1px solid #c7c7c7",
outline: "none"
}}
>

{/* <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    padding: "8px",
    borderBottom: "1px solid #ddd",
    background: "#fff"
  }}
>
  <button
    onClick={exportToExcel}
    style={{
      padding: "6px 12px",
      cursor: "pointer"
    }}
  >
    Export to Excel
  </button>
</div> */}

<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "8px 12px",
   // borderBottom: "1px solid #d1d5db",
    background: "#ffffff"
  }}
>
  <button
    onClick={exportToExcel}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "6px 14px",
      background: "#ffffff",
color: "#5353b9",
border: "1px solid #5353b9",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: 500
    }}
  >
    📄 Export to Excel
  </button>
</div>

{loading && (
  <div style={{ padding: 10 }}>
    Loading...
  </div>
)}

{error && (
  <div style={{ padding: 10, color: "red" }}>
    {error}
  </div>
)}

{!loading && !error && (

   !hasMatrices ? (

    <div
      style={{
        height: "300px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "#6b7280",
        fontFamily: "'Segoe UI'",
        fontSize: "13px",
        fontWeight: 400,
      }}
    >
      No Matrices for the selected node.
    </div>

  ) : (

/*
<table style={styles.table}>*/

<table
  style={{
    ...styles.table,
    userSelect: "none"
  }}
>

<colgroup>

{/* <col style={{width:50}}/>

<col style={{width:180}}/> */}

{/* <col style={{ width: getWidth("sno") }}/> */}
<col style={{ width: 40 }} />

<col style={{ width: getWidth("notation") }}/>

{
/* Array.from({length:maxColumns}).map((_,i)=>(

<col
key={i}
style={{
width:EXCEL_DEFAULT_COL_WIDTH
}}
/> */

/* Array.from({ length: maxColumns }).map((_, i) => {

  const col = groups
    .flatMap(g => g.columns)[i];

  const key =
    col?.columnName ||
    col?.ColumnName ||
    `col-${i}`;

  return (

    <col
      key={i}
      style={{
        width: getWidth(key)
      }}
    />

  );

}) */
Array.from({ length: maxColumns }).map((_, i) => (

  <col
    key={i}
    style={{
      width: EXCEL_DEFAULT_COL_WIDTH
    }}
  />

))


}

</colgroup>

<tbody>

{

sheetRows.map((item,index)=>{

if(item.type==="group"){

return(

<tr key={"g"+index}>

{/* <td
colSpan={2+maxColumns}
style={styles.group}
>
 */}
 <td
colSpan={2+maxColumns}
style={{
  ...styles.group,
  cursor:"pointer"
}}
onClick={() => toggleGroup(item.group.key)}
>
{/* {item.group.title} */}
{collapsedGroups.has(item.group.key) ? "▶ " : "▼ "}
{item.group.title}

</td>

</tr>

);

}

if(item.type==="header"){

return(

<tr key={"h"+index}>

<th
style={{
  ...styles.th,
  cursor:"pointer",
  userSelect:"none"
}}
onClick={() => selectGroup(item.group.key)}
>
◢
</th>



<th
style={{
  ...styles.th,
  position: "relative",
  background:isCellSelected(index,1)
      ? "#d9ebff"
      : "#ececec"
}}

 onMouseDown={() => {

  tableRef.current?.focus();

  setIsSelecting(true);

  setSelectedCell({
    row:index,
    col:1
  });

  setSelectionStart({
    row:index,
    col:1
  });

  setSelectionEnd({
    row:index,
    col:1
  });

  

}}  

  

onMouseEnter={() => {

  if(!isSelecting) return;

  setSelectionEnd({
    row:index,
    col:1
  });

}}

>
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }}
>

  <span>Notation</span>

 {/*  <div
  onMouseDown={(e) => {
    e.stopPropagation();
    startResize(e, "notation");
  }}

  onDoubleClick={(e) => {
    e.stopPropagation();
    autoFitColumn("notation");
  }}
    style={{
      width: "6px",
      height: "100%",
      cursor: "col-resize",
      background: "transparent"
    }}
  /> */}
  {/* <div
  style={{
    position: "absolute",
    top: 0,
    right: -3,
    width: "8px",
    height: "100%",
    cursor: "col-resize",
    userSelect: "none",
    zIndex: 100,
    background: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }} */}
  <div
  className="absolute top-0 -right-[2px] h-full w-[6px] cursor-col-resize z-20"
  onPointerDown={(e) => {
    e.stopPropagation();
    startResize(e, "notation");
  }}
  onDoubleClick={(e) => {
    e.stopPropagation();
    autoFitColumn("notation");
  }}
>
  <div
    style={{
      width: "1px",
      height: "70%",
      //background: "#9e9e9e"
       background: "transparent"
    }}
  />
</div>
</div>
</th>

{
Array.from({length:maxColumns}).map((_,i)=>{
  const col=item.group.columns[i];


  const widthKey =
`${item.group.key}__${
    col?.columnName || col?.ColumnName
}`;


return(

/* <th
key={i}
style={{
    ...styles.th,
    background:
     col && isCellSelected(index,i+2)
        ? "#d9ebff"
        : "#ececec"
}}
> */

<th
key={i}


style={{
  ...styles.th,
  position: "relative",
  overflow: "visible",

  width: getWidth(widthKey),
  minWidth: getWidth(widthKey),
  maxWidth: getWidth(widthKey),

  background:
    col && isCellSelected(index, i + 2)
      ? "#d9ebff"
      : "#ececec"
}}

onMouseDown={() => {

    if(!col) return;

    tableRef.current?.focus();

    setIsSelecting(true);

    setSelectedCell({
        row:index,
        col:i+2
    });

    setSelectionStart({
        row:index,
        col:i+2
    });

    setSelectionEnd({
        row:index,
        col:i+2
    });

}}

onMouseEnter={() => {

    if(!isSelecting || !col) return;

    setSelectionEnd({
        row:index,
        col:i+2
    });

}}

>



{/* {
col
?
(
col.columnCaption
||
col.ColumnCaption
||
col.columnName
||
col.ColumnName
)
:
""
} */}
<div
  style={{
   display: "flex",
justifyContent: "space-between",
alignItems: "center",
width: "100%"
  }}
>

  <span>
    {
      col
        ? (
            col.columnCaption ||
            col.ColumnCaption ||
            col.columnName ||
            col.ColumnName
          )
        : ""
    }
  </span>

  {
    col && (
      
      /*  <div
  className="absolute top-0 -right-[2px] h-full w-[6px] cursor-col-resize z-20" */
 /*  <div
  style={{
    position: "absolute",
    top: 0,
    right: -3,
    width: "8px",
    height: "100%",
    cursor: "col-resize",
    userSelect: "none",
    zIndex: 100,
    background: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }} */
 <div
  className="absolute top-0 -right-[2px] h-full w-[6px] cursor-col-resize z-20"
  onPointerDown={(e) => {
    e.stopPropagation();

    startResize(
      e,
     // col.columnName || col.ColumnName
      `${item.group.key}__${
      col.columnName || col.ColumnName
    }`
    );
  }}
  onDoubleClick={(e) => {
    e.stopPropagation();

    autoFitColumn(
     // col.columnName || col.ColumnName
      `${item.group.key}__${
      col.columnName || col.ColumnName
    }`
    );
  }}
>
  <div
    style={{
      width: "1px",
      height: "70%",
      //background: "#9e9e9e"
        background: "transparent"
    }}
  />
</div>


    )
  }

</div>

</th>

);

})
}

</tr>

);

}

return(

<tr key={"d"+index}>



<td
  style={{
    ...styles.td,
    background: isCellSelected(index, 0)
      ? "#d9ebff"
      : "#fff"
  }}
  onMouseDown={() => {

    tableRef.current?.focus();

    setIsSelecting(true);   // <-- ADD THIS

    setSelectedCell({
      row: index,
      col: 0
    });

    setSelectionStart({
      row: index,
      col: 0
    });

    setSelectionEnd({
      row: index,
      col: 0
    });

  }}

  onMouseEnter={() => {

  if (!isSelecting) return;

  setSelectionEnd({
    row: index,
    col: 0
  });

}}
>
  {item.rowIndex + 1}
</td>

{/* <td
  style={{
    ...styles.td,
    background: isCellSelected(index, 1)
      ? "#d9ebff"
      : "#fff"
  }}
  onMouseDown={() => {

    tableRef.current?.focus();
    setIsSelecting(true);

    setSelectedCell({
      row: index,
      col: 1
    });

    setSelectionStart({
      row: index,
      col: 1
    });

    setSelectionEnd({
      row: index,
      col: 1
    });

  }}

  onMouseEnter={() => {

    if(!isSelecting) return;

    setSelectionEnd({
        row:index,
        col:1
    });

}}
>
  {item.row.notation}
</td> */}
<td
  style={{
    ...styles.td,
    background: isCellSelected(index, 1)
      ? "#d9ebff"
      : "#fff",
    cursor: "pointer",
    color: "#2563eb",
    textDecoration: "underline",
  }}

  /* onClick={() => {

    onNotationSelect?.({
      ...item.row,
      notationHead: item.group.key,
    });

  }} */
 onClick={() => {

  onNotationSelect?.({
    ...item.row,

    tag: -Number(item.row.notationNo),

    notationHead: item.group.key,
  });

}}

  onMouseDown={() => {

    tableRef.current?.focus();

    setIsSelecting(true);

    setSelectedCell({
      row: index,
      col: 1
    });

    setSelectionStart({
      row: index,
      col: 1
    });

    setSelectionEnd({
      row: index,
      col: 1
    });

  }}

  onMouseEnter={() => {

    if (!isSelecting) return;

    setSelectionEnd({
      row: index,
      col: 1
    });

  }}

>
  {item.row.notation}
</td>

{
Array.from({length:maxColumns}).map((_,i)=>{

const col=item.group.columns[i];

if(!col){

return(

<td
key={i}
style={styles.td}
/>

);

}

const key=
col.columnName
||
col.ColumnName;

return(

<td
key={i}
style={{
  ...styles.td,
  background: isCellSelected(index, i + 2)
    ? "#d9ebff"
    : "#fff"
}}


/* onMouseDown={() => {

  tableRef.current?.focus();
  setIsSelecting(true);

  setSelectedCell({
    row: index,
    col: i + 2
  });

  setSelectionStart({
    row: index,
    col: i + 2
  });

  setSelectionEnd({
    row: index,
    col: i + 2
  });

}} */
onMouseDown={() => {

  tableRef.current?.focus();

  setIsSelecting(true);

  setSelectedCell({
    row: index,
    col: i + 2
  });

  setSelectionStart({
    row: index,
    col: i + 2
  });

  setSelectionEnd({
    row: index,
    col: i + 2
  });

  setEditingCell({
    row: index,
    col: i + 2
  });

  setEditValue(
    String(item.row.values[key] ?? "")
  );

}}


onMouseEnter={() => {

    if(!isSelecting) return;

    setSelectionEnd({
        row:index,
        col:i+2
    });

}}

>




{/*{item.row.values[key] ?? ""}*/}
{
editingCell?.row === index &&
editingCell?.col === i + 2
?

<input
    autoFocus

    value={editValue}

    onChange={(e)=>{

        setEditValue(e.target.value);

    }}

    onKeyDown={async (e)=>{

        if(e.key==="Enter"){

            await saveCell(
                item,
                key,
                editValue
            );

        }

        if(e.key==="Escape"){

            setEditingCell(null);

        }

    }}

    onBlur={()=>{
        //setEditingCell(null);
    }}

    style={{
        width:"100%",
        height:"100%",
        border:"none",
        outline:"none",
        background:"transparent",
        padding:0,
        margin:0,
        font:"inherit"
    }}
/>

:

item.row.values[key] ?? ""

}

</td>

);

})
}

</tr>

);

})

}

</tbody>

</table>
  )
)}

</div>

);

}